export type Source = {
	id: number;
	name: string;
	description: string;
	image: string;
};

export const sources: Source[] = [
	{
		id: 1,
		name: "Mayores",
		description:
			"Promovemos el envejecimiento activo y la autonomía a través de redes comunitarias, talleres intergeneracionales y apoyos a la vida independiente.",
		image: "/assets/carrousel-mayores.jpg",
	},
	{
		id: 2,
		name: "Infancia Y Familia",
		description:
			"Prevención, detección temprana y acompañamiento integral para proteger derechos de la infancia y fortalecer competencias parentales.",
		image: "/assets/carrousel-familia.jpg",
	},
	{
		id: 3,
		name: "LGBTI",
		description:
			"Sensibilización, apoyo psicosocial y espacios seguros que fomentan la diversidad y la igualdad de trato en el entorno comunitario.",
		image: "/assets/carrousel-educacionSexual.jpg",
	},
	{
		id: 4,
		name: "Salud Mental",
		description:
			"Intervenciones centradas en la persona: promoción del bienestar emocional, reducción del estigma y acceso a recursos especializados.",
		image: "/assets/carrousel-saludMental.jpg",
	},
	{
		id: 5,
		name: "Medio Ambiente",
		description:
			"Educación ambiental y acciones colaborativas para mitigar el impacto climático y mejorar los entornos donde vivimos.",
		image: "/assets/carrousel-medioAmbiente.jpeg",
	},
	{
		id: 6,
		name: "Formación",
		description:
			"Desarrollo de competencias clave para la empleabilidad, la participación y el liderazgo social de colectivos vulnerables.",
		image: "/assets/carrousel-formacion.jpg",
	},
	{
		id: 7,
		name: "Diversidad Funcional",
		description:
			"Itinerarios personalizados, accesibilidad y apoyos para la vida independiente con enfoque de derechos y autonomía personal.",
		image: "/assets/carrousel-diversidad.jpg",
	},
	{
		id: 8,
		name: "Migración",
		description:
			"Acogida, orientación jurídica y social, e integración comunitaria con mediación intercultural y aprendizaje de la lengua.",
		image: "/assets/carrousel-migracion-2.jpg",
	},
	{
		id: 9,
		name: "Mujer",
		description:
			"Atención integral a víctimas de violencia de género y empoderamiento económico y social para la autonomía de las mujeres.",
		image: "/assets/carrousel-mujeres.jpeg",
	},
	{
		id: 10,
		name: "Personas Sin Hogar",
		description:
			"Intervención en calle, cobertura de necesidades básicas y proyectos de inserción laboral y residencial.",
		image: "/assets/carrousel-sinHogar.jpeg",
	},
];
